import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=e5945eda&"
var script = {}
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5945eda')) {
      api.createRecord('e5945eda', component.options)
    } else {
      api.reload('e5945eda', component.options)
    }
    module.hot.accept("./privacyPolicy.vue?vue&type=template&id=e5945eda&", function () {
      api.rerender('e5945eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/privacyPolicy.vue"
export default component.exports